import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { CallToAction, ACTIONS } from 'components/CallToAction';
export var HowItWorksV1 =
/*#__PURE__*/
function (_Component) {
  _inherits(HowItWorksV1, _Component);

  function HowItWorksV1() {
    _classCallCheck(this, HowItWorksV1);

    return _possibleConstructorReturn(this, _getPrototypeOf(HowItWorksV1).apply(this, arguments));
  }

  _createClass(HowItWorksV1, [{
    key: "renderCta",
    value: function renderCta(ctaCopy, ctaUrl) {
      return React.createElement(CallToAction, {
        action: ACTIONS.LINK,
        extraClass: "bt--primary bt--lg text--left how-it-works-v1__bt",
        to: ctaUrl
      }, ctaCopy);
    }
  }, {
    key: "render",
    value: function render() {
      var title = 'How it works';
      var cards = [{
        image: require('./static/img/card1-v1.jpg'),
        caption: 'Search',
        id: 1
      }, {
        image: require('./static/img/card2-v1.jpg'),
        caption: 'Book',
        id: 2
      }, {
        image: require('./static/img/card3-v1.jpg'),
        caption: 'Go',
        id: 3
      }];

      var phone = require('./static/img/phone.png');

      var subtitle = 'It’s that easy.';
      var copy = 'Whether you’re looking for your favorite class or looking to discover your new thing, the ClassPass app makes it effortless.';
      var ctaCopy = 'Learn more';
      var ctaUrl = '/features';
      return React.createElement("div", {
        className: "how-it-works-v1"
      }, React.createElement("h2", {
        className: "how-it-works-v1__title"
      }, title), React.createElement("div", {
        className: "how-it-works-v1__content"
      }, React.createElement("ol", null, cards.map(function (card) {
        return React.createElement("li", {
          className: "how-it-works-v1__content__step",
          key: card.id
        }, React.createElement("div", null, React.createElement("em", {
          className: "how-it-works-v1__content__step__number"
        }, card.id), React.createElement("h3", {
          className: "how-it-works-v1__content__step__caption"
        }, card.caption)), React.createElement("div", {
          className: "how-it-works-v1__content__step__phone"
        }, React.createElement("img", {
          className: "how-it-works-v1__content__step__phone__screen",
          src: card.image,
          alt: card.caption
        }), React.createElement("img", {
          className: "how-it-works-v1__content__step__phone__frame",
          src: phone,
          alt: card.caption
        })));
      })), React.createElement("div", {
        className: "how-it-works-v1__content__start"
      }, React.createElement("h3", null, subtitle), React.createElement("p", null, copy), React.createElement("div", null, this.renderCta(ctaCopy, ctaUrl)))));
    }
  }]);

  return HowItWorksV1;
}(Component);